import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { logger } from 'utils';
import * as constants from '../constants';
import { iamV4Apis } from 'api/iam-apis';

/**
 * Saga to handle fetching a list of login providers.
 * @param {Object} action - The action object containing payload with options.
 * @returns {void}
 */
export function* getApi(action) {
    const { name, options } = action.payload;
    let apiDetails;

    try {
        apiDetails = iamV4Apis[name];
        const { relatedClass, getFunction } = apiDetails;

        // Fetch login providers
        const { data } = yield call([relatedClass, getFunction], options);

        const responseData = data.getData();

        // Dispatch success action with the fetched data
        yield put({ type: constants.V4_API_FETCH_SUCCESS, name, data: responseData });
    } catch (error) {
        logger('v4 api failed', error);
        const errorType = apiDetails?.errorAction || constants.V4_API_FETCH_FAILED;
        if (apiDetails?.shouldIgnoreError) {
            yield put({ type: constants.V4_API_IGNORE_ERROR, name, error });
            return;
        }
        // Dispatch failure action
        yield put({ type: errorType, name, error });
    }
}

/**
 * Saga to watch for login provider list actions.
 * Triggers the getListLoginProvidersSaga when GET_PROVIDERS_LIST is dispatched.
 * @returns {void}
 */
export function* watchGetV4APIs() {
    yield takeEvery(constants.v4_API_FETCH_REQUEST, getApi);
}

/**
 * Saga to watch for the latest V4 API actions.
 * Triggers the getApi when V4_API_FETCH_REQUEST_THROTTLED is dispatched.
 * @returns {void}
 */
export function* watchGetLatestV4APIs() {
    yield takeLatest(constants.V4_API_FETCH_REQUEST_THROTTLED, getApi);
}
